<template>
  <transition name="fade">
    <div 
      v-if="value" 
      class="tw-fixed tw-inset-0 tw-z-[1100] tw-flex tw-items-center tw-justify-center sm:tw-p-4 tw-bg-black/50 !tw-my-0"
      @click.self="handleOverlayClick"
    >
      <div 
        class="tw-bg-white tw-rounded-none sm:tw-rounded-2xl tw-shadow-2xl tw-max-h-full sm:tw-max-h-[90vh] tw-flex tw-flex-col tw-overflow-hidden dark:tw-bg-dark tw-w-full"
        :class="[maxWidthClass]"
      >
        <!-- HEADER -->
        <div 
          v-if="hasHeader" 
          class="tw-p-5 tw-border-b tw-border-gray-100 dark:tw-border-[#32394e] tw-flex tw-justify-between tw-items-center tw-shrink-0"
        >
          <slot name="header">
            <h5 class="tw-text-lg tw-font-bold tw-text-gray-900 dark:tw-text-white tw-mb-0">{{ title }}</h5>
          </slot>
          <div 
            v-if="showClose"
            type="button" 
            class="tw-text-gray-400 hover:tw-text-gray-600 dark:hover:tw-text-gray-200 tw-cursor-pointer tw-ml-4" 
            @click="close"
          >
            <i class="mdi mdi-close tw-text-2xl"></i>
          </div>
        </div>

        <!-- BODY -->
        <div class="tw-py-4 tw-px-6 tw-overflow-y-auto tw-flex-1">
          <slot></slot>
        </div>

        <!-- FOOTER -->
        <div 
          v-if="hasFooter" 
          class="tw-p-4 tw-bg-gray-50 tw-flex tw-gap-3 tw-justify-end dark:tw-bg-[#32394e] tw-border-t tw-border-gray-100 dark:tw-border-gray-700"
        >
          <slot name="footer"></slot>
        </div>
      </div>
    </div>
  </transition>
</template>

<script>
export default {
  name: 'Dialog',
  props: {
    value: {
      type: Boolean,
      default: false
    },
    title: {
      type: String,
      default: ''
    },
    showClose: {
      type: Boolean,
      default: true
    },
    persistent: {
      type: Boolean,
      default: false
    },
    maxWidth: {
      type: String,
      default: 'lg' // sm, md, lg, xl, 2xl
    },
    lockScroll: {
      type: Boolean,
      default: true
    }
  },
  computed: {
    hasHeader() {
      return !!(this.$slots.header || this.title || this.showClose);
    },
    hasFooter() {
      return !!this.$slots.footer;
    },
    maxWidthClass() {
      const classes = {
        'sm': 'tw-max-w-sm',
        'md': 'tw-max-w-md',
        'lg': 'tw-max-w-lg',
        'xl': 'tw-max-w-xl',
        '2xl': 'tw-max-w-2xl',
        'fit': 'sm:tw-w-fit'
      };
      return classes[this.maxWidth] || classes['lg'];
    }
  },
  watch: {
    value: {
      immediate: true,
      handler(newVal) {
        if (this.lockScroll) {
          if (newVal) {
            document.body.style.overflow = 'hidden';
          } else {
            document.body.style.overflow = '';
          }
        }
      }
    }
  },
  methods: {
    close() {
      this.$emit('input', false);
      this.$emit('close');
    },
    handleOverlayClick() {
      if (!this.persistent) {
        this.close();
      }
    }
  },
  beforeDestroy() {
    if (this.lockScroll && this.value) {
      document.body.style.overflow = '';
    }
  }
}
</script>

<style scoped>
.fade-enter-active, .fade-leave-active {
  transition: opacity 0.3s ease;
}
.fade-enter, .fade-leave-to {
  opacity: 0;
}
</style>
